/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// Environment Globals
import { environment } from '@environment';
import { ConfigService } from '@windriver/authentication';

@Component({
  selector: 'wsn-navbar-wrapper',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  /** Full application name. */
  appName = environment.appName;
  domain: string;
  // domain = environment.domain;
  /** Shortened application name. Usually 3 letters, eg. USP. */
  appShortName = environment.appShortName;
  /** Error message to display in case loading apps list fails. */
  errorMessage: string;
  defaultAppIconName = 'MCP'; // WRD in gallery
  homeAppName = environment.homeAppName;
  currentTheme = 'dark';
  /** Flag that shows the option if necessary. */
  @Input() showOptions: boolean;

  constructor(private router: Router, private configService: ConfigService) {}

  ngOnInit(): void {
    this.configService.configState.subscribe((config: any) => {
      if (config) {
        this.domain = config.domain;
      }
    });
  }
  /**
   * Navigates to app list route.
   * This function is called when user clicks on view all apps menu option.
   */
  openAllApps(): void {
    this.router.navigate(['/apps']);
  }
}
